import React from "react";
import {IconButton, ListItemText} from "@mui/material";
import {Links} from "../../gen/api";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

type Props = {
  link: Links
}

function FormLink({link}: Props) {

  return (
      <>
        <a href={link.link} target="_blank" rel="noopener noreferrer">
          <IconButton color="primary">
            <ArrowRightIcon/>
          </IconButton>
        </a>
        <ListItemText secondary={link.formName}/>
      </>
  );
}

export default FormLink;